// extracted by mini-css-extract-plugin
export default {"integrations-page":"style_integrations-page__iKVJ7","integrations-container":"style_integrations-container__7kG3r"};